export const language = {
  en: '英文',
  'zh-TW': '繁體中文',
  zh_TW: '繁體中文',
  zh_CN: '簡體中文',
};